import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { REACTIONS } from "@/lib/brand";
import AuthModal from "@/components/AuthModal";

export default function ReactionBar({ shortId, initial = {} }) {
  const { user } = useAuth();
  const [counts, setCounts] = useState(initial);
  const [mine, setMine] = useState([]);
  const [authOpen, setAuthOpen] = useState(false);

  useEffect(() => {
    if (user) api.get(`/calls/${shortId}/my-reactions`).then(({ data }) => setMine(data.types || [])).catch(() => {});
  }, [user, shortId]);

  const toggle = async (type) => {
    if (!user) return setAuthOpen(true);
    const { data } = await api.post(`/calls/${shortId}/reactions`, { type });
    setCounts(data.reactions);
    setMine((m) => (data.active ? [...m, type] : m.filter((t) => t !== type)));
  };

  return (
    <div data-testid="reaction-bar" className="flex flex-wrap gap-2">
      {REACTIONS.map((r) => {
        const active = mine.includes(r.type);
        return (
          <button key={r.type} data-testid={`reaction-${r.type}`} onClick={() => toggle(r.type)}
            className={`h-10 px-3 border-2 border-ink font-bold text-sm btn-press shadow-brutal-sm flex items-center gap-1.5 ${active ? "bg-locked" : "bg-white"}`}>
            <span aria-hidden>{r.emoji}</span> {r.label}
            {counts[r.type] ? <span className="font-mono text-xs">{counts[r.type]}</span> : null}
          </button>
        );
      })}
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} title="Sign in to react" />
    </div>
  );
}
